// removed by extract-text-webpack-plugin
module.exports = {"container":"_29ga2YUVaMVq5IpdOQQQaD"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89eab5aa","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/messages/new-message-button/new-message-button.less
// module id = 0bXw
// module chunks = 1